"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["index", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var index = _ref.index,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = 'skeleton bg-secondary';
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])('flex items-center py-5', className)
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-12 h-12 rounded-full ml-12 mr-5')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col min-w-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'mr-2 w-20 h-4')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-20 h-4')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'mr-2 w-40 h-4')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-40 h-4')
  })))));
});
//# sourceMappingURL=ThreadListItem.js.map